<template>
  <div>
    <v-card 
      color="white"
      class="box-shadow border-radius">
      <v-card-text>
        <div
          class="title font-weight-bold black--text mb-1">
          #{{ detail.ajuan_no_reg }}
        </div>

        <div
          class="d-flex align-center mb-4">
          <div>
            Berikut detail data ajuan izin usaha.
          </div>

          <v-spacer />
        </div>

        <div>
          <div
            class="mb-4">
            Status Ajuan

            <v-icon small>mdi-chevron-double-right</v-icon>

            <span
              :class="detail.ajuan_status === 'MENUNGGU VERIFIKASI' ? 'orange--text' :
                    detail.ajuan_status === 'DIPROSES' ? 'blue--text' :
                    detail.ajuan_status === 'DITOLAK' ? 'red--text' :
                    detail.ajuan_status === 'DIKOREKSI' ? 'purple--text' :
                    detail.ajuan_status === 'DISETUJUI' ? 'green--text' :
                    detail.ajuan_status === 'DIHAPUS' ? 'red--text' : ''">
              {{ detail.ajuan_status }}
            </span>
          </div>

          <ul
            class="dashed-list">
            <li
              class="mb-4">
              <div
                class="font-weight-bold mb-1">
                Badan Usaha.
              </div>

              <div
                class="line-text-second">
                {{ detail.ajuan_nama_badan_usaha }}
              </div>
            </li>

            <li
              class="mb-4">
              <div
                class="font-weight-bold mb-1">
                Nomor NIB.
              </div>

              <div
                class="line-text-second">
                {{ detail.ajuan_nib_no }}
              </div>
            </li>

            <li
              class="mb-4">
              <div
                class="font-weight-bold mb-1">
                Alamat NIB.
              </div>

              <div
                class="line-text-second">
                {{ detail.ajuan_nib_alamat }}
              </div>
            </li>

            <li
              class="mb-4">
              <div
                class="font-weight-bold mb-1">
                Luas.
              </div>

              <div
                class="line-text-second">
                {{ detail.ajuan_luas }} M<sup>2</sup>
              </div>
            </li>

            <li
              class="mb-4">
              <div
                class="font-weight-bold mb-1">
                Kegiatan Usaha.
              </div>

              <div
                class="line-text-second">
                {{ detail.ajuan_kbli_judul }}
              </div>
            </li>

            <li
              class="mb-4">
              <div
                class="font-weight-bold mb-1">
                Uraian Kegiatan Usaha.
              </div>

              <div
                class="line-text-second">
                {{ detail.ajuan_kbli_uraian }}
              </div>
            </li>

            <li
              class="mb-4">
              <div
                class="font-weight-bold mb-1">
                Lokasi Usaha.
              </div>

              <div
                class="line-text-second">
                {{ detail.ajuan_lokasi_usaha }}
              </div>
            </li>

            <li
              class="mb-4">
              <div
                class="font-weight-bold mb-1">
                Alamat.
              </div>

              <div
                class="line-text-second">
                {{ detail.ajuan_dukuh }}, RT{{ detail.ajuan_rt }} / RW{{ detail.ajuan_rw }}, Des. {{ detail.ajuan_kelurahan_name }}, Kec. {{ detail.ajuan_kecamatan_name }}
              </div>
            </li>

            <li>
              <div
                class="font-weight-bold mb-1">
                Keterangan.
              </div>

              <div
                class="line-text-second">
                {{ detail.ajuan_keterangan === '' ? '-' : detail.ajuan_keterangan }}
              </div>
            </li>
          </ul>

          <div
            class="text-right black--text mt-8">
            Diajukan Tanggal <strong>{{ detail.ajuan_create_datetime | date }}</strong> Pukul <strong>{{ detail.ajuan_create_datetime | time }}</strong>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        sheet: {
          form: false
        },
        autocomplete: {
          kbli: '',
          subdistrict: '',
          village: ''
        },
        config: {
          kbli: [],
          subdistrict: [],
          village: []
        },
        form: {
          id: '',
          nama_badan_usaha: '',
          nib_no: '',
          nib_alamat: '',
          kbli: '',
          lokasi_usaha: '',
          luas: '',
          keterangan: '',
          lampiran: [],
          koordinat: [],
          extra: {},

          kecamatan_code: '',
          kecamatan_name: '',
          kelurahan_code: '',
          kelurahan_name: '',
          dukuh: '',
          rt: '',
          rw: ''
        },
        process: {
          load: false,
          form: false,
          kbli: false,
          subdistrict: false,
          village: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      
    }
  }
</script>